import { Component, OnInit } from '@angular/core';
import { JobseekerService } from '@admin/jobseekers/shared/services/jobseeker.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LookupService } from '@admin/shared/services/lookup.service';
import {
  AnnouncementMatchingListModel,
  AnnouncementMatchingJobseekerModel,
} from '../shared/models/announcement-matching-list-model';
import { Subscription } from 'rxjs';
import { AnnouncementMatchingService } from '../shared/services/announcement-matching.service';
import { Utils } from '@admin/shared/utils';
import { AnnouncementMatchingJobseekerStatusEnum } from '@admin/stats-and-reports/shared/models/announcement-matching-jobseeker-status-enum';
import { ConfigurationService } from '@admin/shared/services/configuration.service';
import { SelectItem } from 'primeng/api';
import { JobseekerMatchedAnnouncement } from '../shared/models/jobseeker-matched-announcement';
import { UserService } from '@admin/core/user.service';
import { FeatureEnum } from '@admin/shared/models/feature-enum';
import { GenericResult } from '@admin/shared/models/generic-result';
import { ApplicationMessage } from '@admin/core/models/application-message';
import { ApplicationMessageSource } from '@admin/core/models/application-message-source';
import { MessageType } from '@admin/core/models/enum/message-type';
import { CustomMessageService } from '@admin/core/message.service';
import { JobseekerStatusEnum } from '@admin/jobseekers/shared/models/jobseeker-status-enum';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-view-announcement-matching-list',
  templateUrl: './view-announcement-matching-list.component.html',
  styleUrls: ['./view-announcement-matching-list.component.less'],
  standalone: false,
})
export class ViewAnnouncementMatchingListComponent implements OnInit {
  public announcementMatchingList: AnnouncementMatchingListModel;
  public selectedMatchingJobseeker: AnnouncementMatchingJobseekerModel;
  public sub: Subscription;
  public matchingListId: number;

  public displayModal: boolean;

  public mandatoryLanguagesOn: boolean;
  public optionalLanguagesOn: boolean;

  public MatchingJobseekerStatus: any;

  public announcementUrl: string;
  public jobseekersListUrl: string;

  public statuses: SelectItem[];
  public jobseekerMatchedAnnouncements: JobseekerMatchedAnnouncement[];

  public hasViewMatchingListPermission: boolean;
  public hasApproveMatchingListPermission: boolean;
  public hasExpressApprovePermission: boolean;

  public JobseekerStatus = JobseekerStatusEnum;

  constructor(
    private jobseekerService: JobseekerService,
    private route: ActivatedRoute,
    private router: Router,
    private config: ConfigurationService,
    private lookupService: LookupService,
    private messageService: CustomMessageService,
    private userService: UserService,
    private translationService: TranslateService,
    private announcementMatchingService: AnnouncementMatchingService
  ) {
    this.selectedMatchingJobseeker = null;
    this.MatchingJobseekerStatus = AnnouncementMatchingJobseekerStatusEnum;
    this.jobseekerMatchedAnnouncements = [];
    this.hasViewMatchingListPermission = false;
    this.hasApproveMatchingListPermission = false;
    this.hasExpressApprovePermission = false;
    this.statuses = [
      {
        label: this.translationService.instant('label.AllStatuses'),
        value: null,
      },
      {
        label: this.translationService.instant('label.None'),
        value: AnnouncementMatchingJobseekerStatusEnum.None,
      },
      {
        label: this.translationService.instant('label.Accepted'),
        value: AnnouncementMatchingJobseekerStatusEnum.Accept,
      },
      {
        label: this.translationService.instant('label.Rejected'),
        value: AnnouncementMatchingJobseekerStatusEnum.Reject,
      },
      {
        label: this.translationService.instant('label.Ambiguous'),
        value: AnnouncementMatchingJobseekerStatusEnum.Ambiguous,
      },
    ];
  }

  onSelectJobseeker(event) {
    const jobseeker = event.data.jobseeker;

    if (jobseeker.status == JobseekerStatusEnum.Active) {
      this.jobseekerMatchedAnnouncements =
        event.data.jobseekerMatchedAnnouncements;

      this.router.navigate([
        this.jobseekersListUrl,
        'jobseeker',
        jobseeker.jobseekerId,
      ]);
    }
  }

  onUnselectJobseeker() {
    this.router.navigate([this.jobseekersListUrl]);
  }

  onAcceptJobseeker(matchingJobseeker: AnnouncementMatchingJobseekerModel) {
    const data = Utils.cloneObject(
      matchingJobseeker,
      AnnouncementMatchingJobseekerModel
    );

    data.status = AnnouncementMatchingJobseekerStatusEnum.Accept;

    this.announcementMatchingService
      .approveAnnouncementMatchingJobseeker(data)
      .subscribe((c) => {
        matchingJobseeker.status = data.status;
      });
  }

  onRejectJobseeker(matchingJobseeker: AnnouncementMatchingJobseekerModel) {
    const data = Utils.cloneObject(
      matchingJobseeker,
      AnnouncementMatchingJobseekerModel
    );

    data.status = AnnouncementMatchingJobseekerStatusEnum.Reject;

    this.announcementMatchingService
      .approveAnnouncementMatchingJobseeker(data)
      .subscribe((c) => {
        matchingJobseeker.status = data.status;
      });
  }

  onSetJobseekerAmbiguous(
    matchingJobseeker: AnnouncementMatchingJobseekerModel
  ) {
    const data = Utils.cloneObject(
      matchingJobseeker,
      AnnouncementMatchingJobseekerModel
    );

    data.status = AnnouncementMatchingJobseekerStatusEnum.Ambiguous;

    this.announcementMatchingService
      .approveAnnouncementMatchingJobseeker(data)
      .subscribe((c) => {
        matchingJobseeker.status = data.status;
      });
  }

  // onRegenerate() {
  //   let regenerate = confirm(this.translationService.instant('message.AreYouSure'));
  //   if (regenerate) {
  //     this.announcementMatchingService.regenerateMatching(this.announcementMatchingList.announcement.announcementId).subscribe(c => {
  //       alert(this.translationService.instant('message.Queued'));
  //     });
  //   }
  // }

  public onReGenerate(display: boolean) {
    this.displayModal = display;
  }

  public onClose(display: boolean) {
    this.displayModal = display;
  }

  public onUpdateTable(announcementId: number) {
    // this.filterPagingWrapper.filter.announcementId = announcementId;
    // this.onFilter();
  }

  onApproveMatchingList() {
    let approve = confirm(
      this.translationService.instant('message.AreYouSure')
    );
    if (approve) {
      this.announcementMatchingService
        .approveMatchingList(this.announcementMatchingList)
        .subscribe((c) => {
          alert(this.translationService.instant('message.Success'));
        });
    }
  }

  onApprove(announcementMatchingListId: number) {
    this.announcementMatchingService
      .ExpressApprove(announcementMatchingListId)
      .subscribe((d) => {
        this.expressApproveResult(d);
      });
  }

  private expressApproveResult(result: GenericResult) {
    if (result.success) {
      this.messageService.pushMessage(<ApplicationMessage>{
        type: MessageType.Success,
        sourceId: ApplicationMessageSource.global,
        summary: '',
        detail: this.translationService.instant(
          'message.ExpressApproveSuccessful'
        ),
      });
    } else {
      this.messageService.pushMessage(<ApplicationMessage>{
        type: MessageType.Error,
        sourceId: ApplicationMessageSource.global,
        summary: '',
        detail: this.translationService.instant('message.' + result.error),
      });
    }
  }

  ngOnInit() {
    let lookupData = this.lookupService.getCachedLookupData();
    let config = this.config.getCachedConfig();

    let websiteUrl = config.currentWebsite;

    const userFeatures = this.userService.currentUser.features;
    this.hasViewMatchingListPermission = userFeatures.some(
      (f) => f === FeatureEnum.ViewMatchingList
    );
    this.hasApproveMatchingListPermission = userFeatures.some(
      (f) => f === FeatureEnum.ApproveMatchingList
    );
    this.hasExpressApprovePermission = userFeatures.some(
      (f) => f === FeatureEnum.ExpressApprove
    );

    this.sub = this.route.params.subscribe((p) => {
      let matchingListId = +p['listid'];
      this.matchingListId = matchingListId;
      this.announcementMatchingService
        .getAnnouncementMatchingList(matchingListId)
        .subscribe((d) => {
          this.announcementMatchingList = d;

          this.mandatoryLanguagesOn =
            this.announcementMatchingList.announcement.requiredLanguages.some(
              (c) => c.isMandatory
            );
          this.optionalLanguagesOn =
            this.announcementMatchingList.announcement.requiredLanguages.some(
              (c) => !c.isMandatory
            );

          this.announcementUrl =
            websiteUrl +
            '/announcement/' +
            this.announcementMatchingList.announcement.announcementId +
            '/';
          this.jobseekersListUrl =
            'stats-and-reports/announcement-matching-list/' +
            this.matchingListId;
        });
    });
  }
}
